import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.CARD_MANAGEMENT_SYSTEM.DEBIT.HOLDER_MANAGEMENT_MENU;

const HolderManagementMenuLink: Array<LinkItemProps> = [
  {
    name: 'Application Débit',
    level: 3,
    subMenu: [
        {
            name: 'Application Débit',
            link: URL.DEBIT_APPLICATION_MENU.DEBIT_APPLICATION,
            level: 4,
        },
        {
            name: 'Consultation Application Débit',
            link: URL.DEBIT_APPLICATION_MENU.DEBIT_APPLICATION_CONSULTATION,
            level: 4,
        },
    ],
  },
  {
    name: 'Validation Application Débit',
    link: URL.DEBIT_APPLICATION_VALIDATION,
    level: 3,
  },
    
];

export default HolderManagementMenuLink;
